import { CloseIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Heading,
  IconButton,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useLayoutEffect, useState } from "react";
import ChatBox from "../Components/ChatBox/ChatBox";

const LandingPage = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [showChatOnScroll, setShowChatOnScroll] = useState(false);

  useLayoutEffect(() => {
    localStorage.removeItem("access_token");
  }, []);

  const toggleChat = () => {
    setIsChatOpen((prev) => !prev);
  };

  const handleScroll = () => {
    const scrollPosition = window.scrollY;
    if (scrollPosition > 300) {
      setShowChatOnScroll(true);
    } else {
      setShowChatOnScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box>
      {!isChatOpen && (
        <Box
          height="100vh"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="column"
          textAlign="center"
          px={4}
        >
          <Heading
            size="2xl"
            mb={4}
            color="teal.600"
            fontWeight="extrabold"
            letterSpacing="tighter"
            lineHeight="1.1"
            fontSize={{ base: "3xl", md: "5xl", lg: "6xl" }}
          >
            Unlock your{" "}
            <span style={{ color: "#764ba2" }}>financial freedom</span>
          </Heading>

          <Text
            fontSize={{ base: "lg", md: "xl" }}
            color="gray.600"
            mb={8}
            maxW="800px"
            lineHeight="tall"
          >
            Get{" "}
            <span style={{ color: "teal.500", fontWeight: "bold" }}>
              prequalified
            </span>{" "}
            in minutes and check your personalized loan options—no paperwork, no
            hassle. With{" "}
            <span style={{ color: "#764ba2", fontWeight: "bold" }}>Atlas</span>,
            you’re guided by{" "}
            <span style={{ color: "teal.500", fontWeight: "bold" }}>
              real-time AI assistance
            </span>{" "}
            every step of the way.
          </Text>

          <VStack spacing={5}>
            <Text
              fontSize={{ base: "xl", md: "2xl" }}
              color="teal.500"
              fontWeight="medium"
              textTransform="uppercase"
              letterSpacing="wide"
            >
              Fast, Easy, and Seamless Loan Application Process
            </Text>

            <Button
              size="lg"
              colorScheme="teal"
              px={8}
              py={6}
              onClick={toggleChat}
              fontSize="lg"
              fontWeight="bold"
              letterSpacing="wide"
            >
              Click here to get started
            </Button>
          </VStack>
        </Box>
      )}

      <Box
        position="fixed"
        bottom={isChatOpen ? "0" : showChatOnScroll ? "0" : "-100%"}
        left="0"
        width="100%"
        height="90vh"
        zIndex="1000"
        transition="transform 0.5s ease, bottom 0.5s ease"
        backgroundColor="white"
      >
        {isChatOpen && (
          <Box position="absolute" top="30px" right="40px" zIndex="1100">
            <IconButton
              icon={<CloseIcon />}
              onClick={toggleChat}
              aria-label="Close chat"
              bg="teal.500"
              color="white"
              _hover={{ bg: "teal.600" }}
              borderRadius="full"
              size="xs"
              fontSize="12px"
              boxShadow="0 2px 4px rgba(0, 0, 0, 0.15)"
            />
          </Box>
        )}

        <Box flex="1" p={4} overflowY="auto">
          <ChatBox />
        </Box>
      </Box>
    </Box>
  );
};

export default LandingPage;
